import { colorPalette } from '@shared/config/colorsConfig';

export const TOUR_ANCHORS = {
  navHome: 'nav-home',
  navHistory: 'nav-history',
  navChat: 'nav-chat',
  navProfile: 'nav-profile',
  homeProgress: 'home-progress',
  homeActivityCard: 'home-activity-card',
  homeActivityCta: 'home-activity-cta',
  homeSectionLater: 'home-section-later',
  homeSectionCompleted: 'home-section-completed',
} as const;

export const TAB_TOUR_ANCHORS: Record<string, (typeof TOUR_ANCHORS)[keyof typeof TOUR_ANCHORS]> = {
  core: TOUR_ANCHORS.navHome,
  history: TOUR_ANCHORS.navHistory,
  chat: TOUR_ANCHORS.navChat,
  profile: TOUR_ANCHORS.navProfile,
};

export const FIXED_TOUR_ANCHORS: string[] = Object.values(TAB_TOUR_ANCHORS);

export const AUTO_START_POLL_INTERVAL = 300;

export const TOUR_START_STABLE_TICKS = 2;

export const TOUR_WAIT_MAX_ATTEMPTS = 600;

export const TOUR_VIEWPORT_PADDING = 16;

export const TOUR_SPOTLIGHT_PADDING = 8;

export const TOUR_TOOLTIP_MAX_WIDTH = 320;

export const TOUR_TOOLTIP_GAP = 24;

export const TOUR_TOOLTIP_ESTIMATED_HEIGHT = 220;

export const TOUR_SCROLL_SETTLE_TIMEOUT = 1200;

export const TOUR_SCROLL_SETTLE_INTERVAL = 50;

export const TOUR_SCROLL_SETTLE_TICKS = 2;

export const TOUR_OVERLAY_COLOR = colorPalette.black;

export const TOUR_OVERLAY_OPACITY = 0.55;
